import { Carousel } from '@mantine/carousel';
import {
  createStyles,
  Image,
  BackgroundImage,
  Anchor,
  Container,
} from '@mantine/core';
import style from './carousel3CompStyle.module.css';
const useStyles = createStyles((theme) => ({
  container: {
    width: '100%',
  },
  slide: {
    margin: '0!important',
  },
  backgroundImage: {
    height: 317,
    '@media (max-width: 600px)': {
      height: 190,
    },
    '@media (min-width: 600px)': {
      height: 200,
    },
    '@media (min-width: 768px)': {
      height: 250,
    },
    '@media (min-width: 992px)': {
      height: 317,
    },
  },
  containerText: {
    paddingBottom: 0,
  },
  control: {
    backgroundColor: '#F2EEC8',
    color: '#F56600',
    borderColor: '#F2EEC8',
    opacity: 1,
  },
  image: {
    '@media (min-width: 768px)': {
      paddingTop: 100,
    },
    '@media (min-width: 992px)': {
      paddingTop: 130,
    },
  },
}));
function CarouselCompo3(props) {
  const { classes } = useStyles();
  return (
    <Container>
      <Carousel.Slide className={classes.slide}>
        <Anchor href="/#">
          <BackgroundImage
            src={props.image}
            width={600}
            height={317}
            className={`${classes.backgroundImage} ${style.backgroundImages}`}
            radius={20}
            component="a"
            href={props.link}
          >
            <Container
              className={`d-flex justify-content-center ${style.containerTennyImg}`}
            >
              <Image
                src={props.icon}
                className={`${classes.image} `}
                width={50}
                pt={70}
              />
            </Container>
          </BackgroundImage>
        </Anchor>
      </Carousel.Slide>
    </Container>
  );
}

export default CarouselCompo3;
